module.exports = __webpack_public_path__ + "media/images/contest-label-center@2x-b7edc69ef08ae2ec14eccf70118b0edb.png";